import { lazy } from "react"


export default [
    {
        path:"/keamanan",
        component:lazy(() => import('../../views/kemanan/index')),
        exact:true,
    }
    ,
   
]